module.exports = __webpack_public_path__ + "img/sex_2.517f06e2.png";